import {
  activateUserAccount,
  completeAccountPasswordReset,
  requestAccountPasswordReset,
  validateAndActivateAccount,
} from 'api/generated/account-controller/account-controller';

/**
 * Public (unauthenticated) account flows. Containers call these instead of
 * reaching into `market-view-api` or importing Orval modules directly.
 */

export async function sendAccountPasswordResetEmail(email: string): Promise<void> {
  await requestAccountPasswordReset(email, {
    headers: { 'Content-Type': 'text/plain' },
  });
}

export async function completeAccountPasswordResetFlow(args: {
  key: string;
  newPassword: string;
}): Promise<void> {
  await completeAccountPasswordReset({
    key: args.key,
    newPassword: args.newPassword,
  });
}

export async function validateUserActivationKey(
  activationKey: string,
): Promise<void> {
  await validateAndActivateAccount({ key: activationKey });
}

export async function submitUserAccountActivation(args: {
  activationKey: string;
  oktaUserId: string;
  password: string;
}): Promise<void> {
  await activateUserAccount({
    key: args.activationKey,
    oktaUserId: args.oktaUserId,
    password: args.password,
  });
}
